import { Key } from 'common/types/keyboard/key';

/**
 * Wires up a header/footer menu rendered by the `dropdown` helper as a disclosure widget:
 * a button toggling `aria-expanded` and the `hidden` attribute of the list of links it controls.
 */
function bindDisclosure(disclosure) {
  const toggle = disclosure.querySelector('.dropdown-toggle');
  const menu = disclosure.querySelector('.dropdown-options');

  toggle.addEventListener('click', () => {
    if (toggle.getAttribute('aria-expanded') === 'true') {
      close();
    } else {
      open();
    }
  });

  disclosure.addEventListener('keydown', (event) => {
    if (event.key === Key.Escape && toggle.getAttribute('aria-expanded') === 'true') {
      close();
      toggle.focus();
    }
  });

  disclosure.addEventListener('focusout', (event) => {
    if (event.relatedTarget && !disclosure.contains(event.relatedTarget)) {
      close();
    }
  });

  document.addEventListener('click', (event) => {
    if (!disclosure.contains(event.target)) {
      close();
    }
  });

  window.addEventListener('resize', positionMenu);

  function open() {
    menu.hidden = false;
    disclosure.classList.add('active');
    toggle.setAttribute('aria-expanded', 'true');
    positionMenu();
  }

  function close() {
    menu.hidden = true;
    disclosure.classList.remove('active');
    toggle.setAttribute('aria-expanded', 'false');
  }

  // Shift the menu left when it would otherwise hang off the right edge of the page
  function positionMenu() {
    if (menu.hidden) {
      return;
    }

    let left = 0;
    let node = menu;
    do {
      left += node.offsetLeft;
      node = node.offsetParent;
    } while (node !== null);

    if (menu.offsetWidth + left >= document.body.offsetWidth || menu.style.left) {
      const toggleWidth = disclosure.getBoundingClientRect().width;
      menu.style.left = `${-(menu.offsetWidth - toggleWidth)}px`;
    }
  }
}

/**
 * Binds every `[data-site-chrome-disclosure]` menu inside the given element.
 */
export function bindDisclosures(element) {
  if (!element) {
    return;
  }

  element.querySelectorAll('[data-site-chrome-disclosure]').forEach(bindDisclosure);
}
